// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3rcf3","clinicsSelect":"styles_clinicsSelect__xCgIY"};